// Form Helper Functions - Following reference pattern
export const handleInputChange = (e, formData, setFormData) => {
	setFormData({ ...formData, [e.target.name]: e.target.value });
};

export const handleNumberInputChange = (
	fieldName,
	fieldValue,
	formData,
	setFormData,
) => {
	setFormData({ ...formData, [fieldName]: fieldValue });
};

export const handleSelectChange = (
	fieldName,
	fieldValue = null,
	formData,
	setFormData,
) => {
	setFormData({ ...formData, [fieldName]: fieldValue });
};

export const handleDateChanged = (
	fieldValue,
	fieldName,
	formData,
	setFormData,
) => {
	setFormData({
		...formData,
		[fieldName]: fieldValue,
	});
};

export const filterByLabel = (input, option) => {
	// Support both option.props.label (for Select with children) and option.label (for Select with options prop)
	const label = option?.label || option?.props?.label || '';
	return label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
};

